// Central path constants for the wireframe prototype so the hub links,
// the router, and tests all agree. HashRouter paths (no leading '#').
export const WIREFRAME_BASE = '/wireframes'

export const WIREFRAME_PATHS = {
    hub: WIREFRAME_BASE,
    library: `${WIREFRAME_BASE}/classifiers`,
    edit: `${WIREFRAME_BASE}/classifiers/edit`,
    orgList: `${WIREFRAME_BASE}/orgs`,
    orgConfig: `${WIREFRAME_BASE}/org`,
    teamConfig: `${WIREFRAME_BASE}/team`,
    profileConfig: `${WIREFRAME_BASE}/profile`,
    orgUsers: `${WIREFRAME_BASE}/org/users`,
    // Single-user detail. The real route carries the user id (see userDetailPath);
    // this bare constant is the router-pattern prefix the user tables link into.
    userDetail: `${WIREFRAME_BASE}/org/user`,
    clientOrg: `${WIREFRAME_BASE}/org/client`
} as const

// Builds the link a user-table row points at. Every user table in the prototype
// (org / team / profile) routes through here, so one user page serves them all.
export const userDetailPath = (userId: string): string =>
    `${WIREFRAME_PATHS.userDetail}/${userId}`
